var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "site-link",
    {
      staticClass: "margin-right-md",
      attrs: { to: { name: "account.billing", hash: "#metered-billing" } },
      nativeOn: {
        click: function ($event) {
          return _vm.$posthog.capture(`usage:${_vm.actionEventName}`)
        },
      },
    },
    [_c("strong", [_vm._v(_vm._s(_vm.actionLabel))])]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }